import React, { useState } from 'react';
import { Container, Box, Grid, Typography, Button } from '@mui/material';
import {
    FavoriteOutlined as FavoriteOutlinedIcon,
    VerifiedUserOutlined as VerifiedUserOutlinedIcon,
    AttachMoneyOutlined as AttachMoneyOutlinedIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import EmailCollectionModal from '../EmailCollectionModal';
import { saveEmailSignup } from '../../utils/api';

const WhyParticipateSection = ({ FadeInSection }) => {
    const navigate = useNavigate();
    const [emailModalOpen, setEmailModalOpen] = useState(false);

    const handleEmailSubmit = async (data) => {
        try {
            await saveEmailSignup(data.name, data.email, 'why_participate_section', '10%');
            alert('Dziękujemy! Otrzymasz 10% rabatu na ostateczną wersję Find solution.');
        } catch (error) {
            console.error('Error saving email:', error);
            throw error;
        }
    };

    const benefits = [
        {
            icon: FavoriteOutlinedIcon,
            title: 'Pomóż nam stworzyć idealną aplikację',
            description: 'Twoja opinia jest bezcenna. To Ty decydujesz, jakie funkcje są najważniejsze.',
            bgcolor: 'grey.100',
            iconColor: 'primary.main',
            buttonText: 'Weź udział w badaniu teraz',
            buttonAction: () => navigate('/ankieta')
        },
        {
            icon: VerifiedUserOutlinedIcon,
            title: 'Darmowy dostęp do wersji testowej',
            description: 'Przetestuj, jak działa Find solution, zanim będzie dostępna dla wszystkich.',
            bgcolor: 'grey.100',
            iconColor: 'secondary.main',
            buttonText: 'Przetestuj aplikację',
            buttonAction: () => navigate('/zmiana-pracy')
        },
        {
            icon: AttachMoneyOutlinedIcon,
            title: 'Zdobądź rabat',
            description: 'Zapisz się na listę oczekujących i zdobądź zniżkę na start.',
            bgcolor: 'grey.100',
            iconColor: 'secondary.main',
            buttonText: 'Dołącz do listy oczekujących',
            buttonAction: () => setEmailModalOpen(true)
        }
    ];

    return (
        <Box sx={{ py: 8, bgcolor: 'white' }}>
            <Container maxWidth="lg">
                <FadeInSection>
                    <Typography
                        variant="h3"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: 'grey.800',
                            mb: 3
                        }}
                    >
                        Dlaczego warto wziąć udział w badaniu?
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            textAlign: 'center',
                            color: 'grey.700',
                            mx: 'auto',
                            mb: 6,
                            lineHeight: 1.8
                        }}
                    >
                        Jesteśmy startupem tworzącym innowacyjne narzędzie do rozwoju zawodowego i osobistego. Nasza aplikacja pozwala odkryć mocne strony, planować działania w obszarach kariery, rozwoju osobistego, relacji i budowania nawyków. Dla potrzeb procesu inkubacji pomysłu realizujemy badanie, które pomoże nam lepiej dopasować aplikację do potrzeb użytkowników.
                    </Typography>
                </FadeInSection>

                <Grid container spacing={4} justifyContent="center">
                    {benefits.map((benefit, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <FadeInSection delay={index * 0.1}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: 4,
                                    borderRadius: 3,
                                    bgcolor: benefit.bgcolor,
                                    height: '320px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }}>
                                    <Box>
                                        <benefit.icon sx={{ fontSize: 50, color: benefit.iconColor, mb: 2 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: 'grey.800' }}>
                                            {benefit.title}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'grey.600', lineHeight: 1.6, mb: 3 }}>
                                            {benefit.description}
                                        </Typography>
                                    </Box>
                                    <Button
                                        onClick={benefit.buttonAction}
                                        variant="contained"
                                        sx={{
                                            background: 'linear-gradient(90deg, #c79a5f, #9b7b5e)',
                                            color: 'white',
                                            py: 1.5,
                                            px: 3,
                                            borderRadius: 2,
                                            fontWeight: 'bold',
                                            fontSize: '1rem',
                                            textTransform: 'none',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                                boxShadow: '0 8px 25px rgba(199, 154, 95, 0.3)'
                                            },
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {benefit.buttonText}
                                    </Button>
                                </Box>
                            </FadeInSection>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            <EmailCollectionModal
                open={emailModalOpen}
                onClose={() => setEmailModalOpen(false)}
                onSubmit={handleEmailSubmit}
                title="Dołącz do listy oczekujących"
                description="Podaj swoje dane, aby otrzymać 10% rabatu na ostateczną wersję Find solution."
            />
        </Box>
    );
};

export default WhyParticipateSection;
